import { CapraIcon, capraIconDefinition, capraIconSchemaTable } from '@mode/capra';
import { COLUMN_ICON_MAP, iconClassFromColumnType } from '@mode/shared/util-js';

type TableType = 'definition' | 'table';

type TableIconMap = {
  [key in TableType]: CapraIcon;
};

const TABLE_ICON_MAP: TableIconMap = {
  definition: capraIconDefinition,
  table: capraIconSchemaTable,
};

export function createColumnIconClass(type: string): string {
  return `column ${iconClassFromColumnType(type)} icon-mask`;
}

export function createTableIconClass(suggestionType: TableType) {
  const icon = TABLE_ICON_MAP[suggestionType];
  return `table ${icon.name} icon-mask`;
}

export function addAutoCompleteIconsAsStyles(element: HTMLElement) {
  // Capra icons don't support class based selection. For the ace editor, we have to provide
  // icons as a class, so we'll add those as a style element
  let iconCss = '';
  const sheet = document.createElement('style');
  sheet.id = 'capra-icons';

  Object.values(TABLE_ICON_MAP).forEach((value) => {
    iconCss += createIconCss(value);
  });

  Object.values(COLUMN_ICON_MAP).forEach((value) => {
    iconCss += createIconCss(value);
  });

  sheet.innerHTML = iconCss;
  element.prepend(sheet);
}

function createIconCss(capraIcon: CapraIcon) {
  // Add the icon as a mask image so we can alter the color for each theme.
  // Color is definied by .icon-mask
  return `.${capraIcon.name} {
      mask-image: url('data:image/svg+xml;utf8,${capraIcon.data}');
      -webkit-mask-image: url('data:image/svg+xml;utf8,${capraIcon.data}');
    } \n`;
}
